<template>
  <div class="ai-jobs">
    <Stack
      class="stk-p-6"
      gap="4"
    >
      <Level>
        <LevelLeft>
          <Stack gap="0">
            <Title>
              AI Jobs
            </Title>

            <Subtitle>
              Create automated AI commands and get the results delivered straight to your inbox
            </Subtitle>
          </Stack>
        </LevelLeft>
        <LevelRight>
          <Button
            variant="primary"
            @click="showNew = true"
          >
            New AI Job
          </Button>
        </LevelRight>
      </Level>
    </Stack>

    <JobsList />

    <StakeModal
      v-model="showNew"
      no-max-width
    >
      <NewJob @done="handleDone" />
    </StakeModal>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Button, Level, LevelLeft, LevelRight, Stack, StakeModal, Subtitle, Title } from '@stakeui';
import JobsList from '../components/JobsList.vue';
import NewJob from '../components/NewJob.vue';

const showNew = ref(false);

const handleDone = () => {
  showNew.value = false;
};
</script>

<style scoped>
</style>


